import type { TextFieldProps } from '@mui/material'
import { TextField } from '@mui/material'
import type { ForwardedRef } from 'react'
import { forwardRef } from 'react'

import LabeledTextField, { LabeledTextFieldWithTooltip } from '@/components/dataDisplay/LabeledTextField'

export type EditableTextFieldProps = TextFieldProps & {
  isEditable?: boolean
  label: string
  // Optional text to display when not editable. It will be used instead of the value prop.
  text?: string
  // Optional tooltip to display next to the label when not editable.
  tooltip?: string
}

function EditableTextField(
  { label, isEditable = false, text, tooltip, ...props }: EditableTextFieldProps,
  ref: ForwardedRef<HTMLInputElement | HTMLDivElement>,
) {
  if (isEditable) {
    return <TextField ref={ref} {...props} label={label} sx={{ backgroundColor: 'white' }} value={props.value ?? ''} />
  }

  if (tooltip) {
    return <LabeledTextFieldWithTooltip label={label ?? ''} text={text ?? props.value?.toString()} tooltip={tooltip} />
  }

  return <LabeledTextField label={label ?? ''} text={text ?? props.value?.toString()} />
}

export default forwardRef(EditableTextField)
